import IconSvgContainer, { IconProps, IconSize } from "../IconSvgContainer"

export default function BiomassIcon({ size = IconSize.medium }: IconProps) {
	return (
		<IconSvgContainer
			size={size}
			fill={true}
			viewBox={"0 0 39.687504 39.6875"}
			stroke={false}
		>
			<g
				strokeWidth={"0"}
				transform="translate(-85.23304,-128.65623)"
			>
				<g
					strokeWidth={"0"}
					transform="matrix(2.2048611,0,0,2.2048611,78.618393,122.04167)"
				>
					<path
						strokeWidth={"0"}
						d="m 4.9999514,2.9999893 c -1.0999978,0 -1.9999219,0.8999241 -1.9999219,1.9999219 V 19.000067 c 0,1.099998 0.8999241,1.999922 1.9999219,1.999922 H 19.000108 c 1.099998,0 1.999922,-0.899924 1.999922,-1.999922 V 4.9999112 c 0,-1.0999978 -0.899924,-1.9999219 -1.999922,-1.9999219 z m 0.4567969,2.5000781 h 3.4999219 v 1.5 H 5.9566701 v 0.9998438 h 2.0001563 c 0.5500024,0 0.9998438,0.4500803 0.9998438,1.0000781 v 1.6045317 c 0,0 0.1352616,0.895546 -0.8594532,0.895546 H 4.4566701 v -1.5 H 7.4566702 V 8.9999893 H 5.4567483 c -0.5499997,0 -1.0000782,-0.4500803 -1.0000782,-1.0000781 v -1.5 c 0,-0.5500024 0.4500785,-0.9998438 1.0000782,-0.9998438 z m 5.2964067,0 h 3.499921 v 1.5 h -3 v 0.9998438 h 1.999922 v 1.0000781 h -1.999922 v 1.0000777 h 3 v 1.5 h -3.499921 c -0.550003,0 -1.0000786,-0.450075 -1.0000786,-1.000078 V 6.4999112 c 0,-0.5500024 0.4500756,-0.9998438 1.0000786,-0.9998438 z m 5.290078,0.040547 h 3.499922 v 1.5 h -2.999766 v 1.0000781 h 1.999922 v 0.9998438 h -1.999922 v 1.0000777 h 2.999766 v 1.5 h -3.499922 c -0.550003,0 -0.999844,-0.450075 -0.999844,-1.000078 V 6.5406924 c 0,-0.5500023 0.449841,-1.0000781 0.999844,-1.000078 z M 7.0987795,12.499911 H 11.59878 c 0.549996,0 1.000078,0.450082 1.000078,1.000078 v 4.999922 h -1.5 v -4.5 H 10.09878 v 3 H 8.5987795 v -3 H 7.5989358 v 4.5 h -1.5 v -4.999922 c 0,-0.549996 0.4498452,-1.000078 0.9998437,-1.000078 z m 6.3023435,0 h 3.500157 c 0.549992,0 0.999843,0.450082 0.999843,1.000078 v 2.500078 c 0,0.549998 -0.449851,0.999844 -0.999843,0.999844 h -2.000157 v 1.5 h -1.5 z m 1.5,1.5 v 1.5 h 1.5 v -1.5 z"
					/>
				</g>
			</g>
		</IconSvgContainer>
	)
}
